// extracted by mini-css-extract-plugin
export var menuIcon = "_ra-0";
export var menuIconInline = "_ra-1";